class BlogPosts extends HTMLElement {
  constructor() {
    super()

    this.selectors = {
      sidebar: "[js-sidebar]",
      sidebarImageWrapper: "[js-image-wrapper]",
      sidebarLink: "[js-sidebar-link]",
    }
  }

  connectedCallback() {
    this.sidebar = this.querySelector(this.selectors.sidebar)

    if (this.sidebar === null) return

    this.sidebarImageWrapper = this.sidebar.querySelectorAll(
      this.selectors.sidebarImageWrapper,
    )

    this.eventController = new AbortController()
    const eventOptions = { signal: this.eventController.signal }

    this.sidebar.addEventListener("mouseleave", () => {
      this.sidebar.dataset.cursorWithin = false
    })

    this.sidebarImageWrapper.forEach((wrapper) => {
      const parentMetaEl = wrapper.parentElement
      const sidebarImage = parentMetaEl.querySelector("img")
      const hoverTrigger = parentMetaEl.querySelector(
        this.selectors.sidebarLink,
      )

      hoverTrigger.addEventListener(
        "mouseenter",
        () => {
          setTimeout(() => {
            this.sidebar.dataset.cursorWithin = true
          }, 240) // give the mouse-in animation some time
        },
        eventOptions,
      )

      hoverTrigger.addEventListener(
        "mousemove",
        (e) => {
          sidebarImage.style.left = `${
            e.clientX - e.target.getBoundingClientRect().left
          }px`
        },
        eventOptions,
      )
    })
  }

  disconnectedCallback() {
    this.eventController.abort()
  }
}

if (!customElements.get("blog-posts")) {
  customElements.define("blog-posts", BlogPosts)
}
